var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4133 0.231918L7 5.00889L1.58666 0.231918C1.41008 0.081423 1.17358 -0.00185115 0.928105 3.12318e-05C0.682626 0.00191361 0.447805 0.0888018 0.274218 0.241982C0.100632 0.395162 0.00216854 0.602379 3.53924e-05 0.819C-0.00209776 1.03562 0.09227 1.24432 0.262814 1.40014L6.33527 6.75874C6.42235 6.8359 6.52598 6.89698 6.64012 6.9384C6.75425 6.97982 6.87659 7.00076 7 6.99998C7.12337 7.00053 7.24564 6.97949 7.35973 6.93808C7.47383 6.89667 7.57749 6.83572 7.66473 6.75874L13.7372 1.40014C13.9077 1.24432 14.0021 1.03562 14 0.819C13.9978 0.602379 13.8994 0.395162 13.7258 0.241982C13.5522 0.0888018 13.3174 0.00191361 13.0719 3.12318e-05C12.8264 -0.00185115 12.5899 0.081423 12.4133 0.231918Z",
    fill: "#869FB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.4395fb935d12d833272f6f535a6e0d2d.svg";
export { ForwardRef as ReactComponent };